"use client";
import React, { useCallback } from "react";

import CartDropdownItems from "./CartDropdownItems";

import * as matomo from "../../../../modules/analytics/utils/matomo";

import useAppContext from "../../../theme/hooks/useAppContext";
import useSetCurrentClient from "../../../common/utils/useSetCurrentClient";
import { useTranslations } from "next-intl";
import useCurrentUser from "../../../auth/hooks/useCurrentUser";
import Icon from "../../../common/components/Icon";
import ClientChooser from "../ClientChooser";
import Button from "../../../theme/components/Button";
import getCartItemCount from "../../utils/getCartItemCount";

const CartDropdown = ({
  currentClient,
  onClose,
  className = "",
  hidden = false,
  cart,
}) => {
  const { currentUser } = useCurrentUser();

  const t = useTranslations();
  const cartItemCount = getCartItemCount(cart);
  const { clientChooserOpen, cartOpen, toggleClientChooser, toggleCart } =
    useAppContext();
  const { setCurrentClient } = useSetCurrentClient();
  const showCartSwitch = !currentUser?.self?.isPrivateCustomer;

  const clientChooserToggle = useCallback(
    async (selected) => {
      if (selected) {
        matomo.trackEvent("Cart", "Client changed", selected._id);
        await setCurrentClient({ clientId: selected._id });
      }
      toggleClientChooser(false);
      toggleCart(true);
    },
    [setCurrentClient, toggleClientChooser, toggleCart],
  );
  const renderContent = () => {
    if (clientChooserOpen) {
      return (
        <div className="client-chooser-wrap">
          <ClientChooser
            onSelected={clientChooserToggle}
            showCartItemsCount
            defaultOpen
            showInstitutions
          />
        </div>
      );
    }
    if (cartOpen) return <CartDropdownItems cart={cart} />;
    return null;
  };

  return (
    <div hidden={hidden} className={`dropdown dropdown--cart ${className}`}>
      <div className="dropdown--cart__inner color-bg-white">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <small className="fs-8">{t("cart")}</small>
          <div style={{ float: "right" }}>
            <Button
              appearance="quaternary"
              className="hide-on-not-mobile px-0"
              type="button"
              onClick={onClose}
              icon="close"
            />
          </div>
        </div>

        {showCartSwitch ? (
          <Button
            appearance="quaternary"
            type="button"
            icon={`${clientChooserOpen ? "chevron-down" : "chevron-right"}`}
            iconPosition="right"
            className="mb-2 color-secondary-dark w-100 d-flex justify-content-between align-items-center p-0"
            aria-label={t("change_cart")}
            onClick={toggleClientChooser}
          >
            <div className="d-flex align-items-center gap-2 fs-5">
              {currentClient?.isInstitution && (
                <Icon className="ms-0" icon="building" />
              )}
              <span className="d-inline-block">{currentClient?.name}</span>
              <span className="dropdown--cart__count hide-on-not-mobile">
                {cartItemCount}
              </span>
            </div>
          </Button>
        ) : (
          <div />
        )}

        {renderContent()}
      </div>
    </div>
  );
};

export default CartDropdown;
